import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginFormValidate } from '@com-delta-idp/mnx-login-ui';
import { ChallengeScreenError, OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { VIEW_NAME } from '../../constants/login-constant';
import { forgotLoginRequestPayload } from '../../models/forgot-login-interface';
import { ForgotLoginFacadeHelperService } from './forgot-login-facade-helper.service';
@Injectable({
  providedIn: 'root'
})
export class ForgotLoginFacadeService extends ForgotLoginFacadeHelperService {
  checkEmailDisplayView$: BehaviorSubject<string> = new BehaviorSubject<string>(
    ''
  );

  unSubscribe = new Subject();

  constructor() {
    super();
    this.getPageContent();
  }

  getPageContent() {
    this.loginContentService
      .getStaticContentForLoginAuthScreen()
      .pipe(takeUntil(this.unSubscribe))
      .subscribe(async (response) => {
        this.aemContent = response[0];
        this.authenticationConfig = response[1];
        const transformedContent =
          await this.forgotLoginAdapter.getForgotLoginContentAdapter(
            this.aemContent,
            this.authenticationConfig
          );
        this.forgotLoginContent$.next(transformedContent);
      });
  }

  forgotLoginformValueChange(): void {
    this.getForgotLoginContent()?.formGroup?.valueChanges.subscribe(() => {
      this.getForgotLoginContent().forgotLoginAttributes.errorCount =
        LoginFormValidate.validateFormFields(
          this.getForgotLoginContent().formGroup
        );
      this.getForgotLoginContent().forgotLoginAttributes.errorAlertBanner =
        LoginFormValidate.getErrorAlert(this.getForgotLoginContent().formGroup);
    });
  }

  _processError(
    error: HttpErrorResponse | ChallengeScreenError,
    request: forgotLoginRequestPayload
  ) {
    this.pingOauthService
      .getAuthConfigContent()
      .pipe(takeUntil(this.unSubscribe))
      .subscribe((authConfig) => {
        if (authConfig.ERROR_428) {
          if (error instanceof ChallengeScreenError) {
            this.loggingService.log(
              'Status Code: 428 - Display Code Challenge: ' + error
            );
          } else {
            this.redirectEmailScreen(error, request, authConfig);
          }
        } else {
          this.redirectEmailScreen(error, request, authConfig);
        }
      });
  }

  checkRedirectToCheckYourEmail(authConfig: OauthAEMConfig) {
    if (!authConfig.MFA_FLOW) {
      this.redirectToCheckYourEmail();
    } else {
      this.facadeService.getContent().errorMessage =
        this.checkEmailFacadeService.getContent().mfaCheckEmailMessage;
      this.facadeService.getContent().loginFormAttributes.formAlertSuccessIcon =
        true;
      this.facadeService.getContent().errorCode =
        this.facadeService.getContent().errorMessage;
      this.facadeService.getContent().pageContent.mfaSuccess = true;
      this.checkEmailFacadeService.routeBasedOnPosition(
        VIEW_NAME.LOGIN_CREDENTIALS_SCREEN
      );
    }
  }

  onForgotLoginFormSubmit(submit = false) {
    if (submit) {
      this.getForgotLoginContent().forgotLoginAttributes.submitAttempt = true;
      if (!this.getForgotLoginContent().formGroup.valid) {
        this.getForgotLoginContent().forgotLoginAttributes.errorCount =
          LoginFormValidate.validateFormFields(
            this.getForgotLoginContent().formGroup
          );
        this.getForgotLoginContent().forgotLoginAttributes.errorAlertBanner =
          LoginFormValidate.getErrorAlert(
            this.getForgotLoginContent().formGroup
          );
        LoginFormValidate.touchControlsOnForgotLoginSubmit(
          this.getForgotLoginContent()
        );
      } else {
        const request = this.getRequestPayload();
        this.getForgotLoginContent().errorCode = undefined;
        this.disableButton(true);
        this.forgotLoginContentService
          .getForgotLoginData(request)
          .pipe(
            takeUntil(this.unSubscribe),
            switchMap((response) =>
              this.pingOauthService
                .getAuthConfigContent()
                .pipe(map((authConfig) => ({ authConfig, response })))
            )
          )
          .subscribe(
            ({ authConfig, response }) => {
              if (response.errors) {
                this.handleError(response.errors);
              } else {
                let message = '';
                if (authConfig.NEW_RESET_PASSWORD_FLOW) {
                  this.setForgotLoginFormValues(request);
                } else if (response?.email) {
                  message = this.checkEmailFacadeService.replaceBffEmail(
                    response.email
                  );
                  this.checkEmailFacadeService.getContent().checkEmailMessage =
                    message;
                }
                this.checkRedirectToCheckYourEmail(authConfig);
              }
            },
            (err) => {
              this.loggingService.log(err);
              this._processError(err, request);
            }
          );
      }
    }
  }
}
